import React, { useState, useEffect, useContext } from "react";
import { ScenariosIcons } from "./ScenariosIcons";
import Carousel from "react-elastic-carousel";
import { ModalComp } from "../../shared";
import { LeftSection } from "../../context/LeftSectionContext";
import { automationList } from "../../api";
import Cookies from "js-cookie";
import { ScenariosModal } from "../../shared/Scenarios/ScenariosModal";

import { AutommationsModal } from "../../shared/Automation/AutomationsModal";
import { AutomationAdd } from "../../shared/Automation/AutomationAdd";

const Automations = () => {
  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const { show } = useContext(LeftSection);
  const [automation, setAutomation] = useState({});
  const token = Cookies.get("token");
  const [openAddScenarioModal, setOpenAddScenarioModal] = useState(false);
  const [automationsList, setAutomationsList] = useState([]);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const breakPoints = [
    { width: 400, itemsToShow: 5 },
    { width: 550, itemsToShow: 9 },
    // { width: 850, itemsToShow: 12 },
    // { width: 1000, itemsToShow: 9 },
  ];
  const toggleScenarioModal = (automation) => {
    setOpenScenarioModal(!openScenarioModal);
    setAutomation(automation);
  };
  const toggleAddScenario = () => {
    setOpenAddScenarioModal(!openAddScenarioModal);
  };

  useEffect(() => {
    automationList(token)
      .then((result) => {
        setAutomationsList([
          ...result.data.data,
          { title: "افزودن", icon: "icon-plus" },
        ]);
      })
      .catch((error) => {
        if (error.response.status === 403) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: "خطایی رخ داده است",
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
      });
  }, [openScenarioModal, openAddScenarioModal]);

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 576) {
      setIsPhone(true);
    }
  }, []);

  return (
    <>
      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenarioModal}
        component={
          <AutommationsModal
            automation={automation}
            closeModal={setOpenScenarioModal}
          />
        }
      />
      {console.log(automation)}
      <ModalComp
        modal={openAddScenarioModal}
        toggle={toggleAddScenario}
        component={<AutomationAdd />}
      />

      {/* <div className="d-flex text-center my-1" style={{ height: '100px' }}> */}
      <div className="d-flex text-center my-1" style={{ height: "100px" }}>
        <Carousel itemsToScroll={1} breakPoints={breakPoints}>
          {automationsList.length ? (
            automationsList.map((automation, index) => {
              return (
                <ScenariosIcons
                  name={automation.title}
                  type={automation.icon.slice(5)}
                  icon={automation.icon}
                  key={index}
                  toggleScenarioModal={() => {
                    automation.icon === "icon-plus"
                      ? toggleAddScenario()
                      : toggleScenarioModal(automation);
                  }}
                />
              );
            })
          ) : (
            <p>در حال حاضر اتوماسیونی تعریف نشده است</p>
          )}
        </Carousel>
      </div>
    </>
  );
};

export { Automations };
